import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDocker,
  faUbuntu,
  faLinux,
} from "@fortawesome/free-brands-svg-icons";
import {
  faServer,
  faNetworkWired,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import AImg from "./subcomponents/about/AImg";

import photo from "../assets/img/img2.jpg";

const Homeserver = () => {
  return (
    <section
      id="homeserver"
      className="py-12 p-8 flex flex-col lg:flex-row justify-center items-center gap-8"
    >
      <div className="flex flex-col items-start justify-center gap-4 max-w-[35rem]">
        <h2 className="font-bold text-xl font-montserrat-black text-primary bg-primary bg-opacity-30 p-4 w-fit whitespace-nowrap">
          Outside Web Development
        </h2>

        <h3 className="font-montserrat-black text-3xl">
          Home Server with Ubuntu & Docker
        </h3>

        <p className="text-lg font-montserrat text-neutral-300 text-justify">
          Beyond web development, I run a personal home server powered by Ubuntu
          Server and Docker. It hosts a variety of self-hosted services managed
          through Docker Compose - from media servers to monitoring dashboards
          and databases. This setup taught me Linux system administration,
          networking, container orchestration, and infrastructure-as-code
          practices that complement my development skills.
        </p>

        <ul className="flex flex-wrap gap-2 mt-2">
          {[
            "Ubuntu Server",
            "Docker",
            "Docker Compose",
            "Linux CLI",
            "Self-Hosting",
          ].map((tech) => (
            <li
              key={tech}
              className="text-sm font-montserrat-bold text-primary bg-primary bg-opacity-20 px-3 py-1 rounded-full"
            >
              {tech}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-6 max-w-[20rem]">
        <div className="grid grid-cols-3 gap-6 max-w-[20rem]">
          {[
            { icon: faServer, label: "Server" },
            { icon: faDocker, label: "Docker" },
            { icon: faUbuntu, label: "Ubuntu" },
            { icon: faLinux, label: "Linux" },
            { icon: faNetworkWired, label: "Network" },
            { icon: faDatabase, label: "Database" },
          ].map(({ icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center gap-2 p-4 bg-neutral-800 rounded-xl"
            >
              <FontAwesomeIcon
                icon={icon}
                size="2xl"
                className="text-primary"
              />
              <span className="text-sm font-montserrat text-neutral-300">
                {label}
              </span>
            </div>
          ))}
        </div>
        <AImg image={photo} alt="Daniel Kowalski Photo" />
      </div>
    </section>
  );
};

export default Homeserver;
